import type {WebGLRenderTarget} from "../../_types/WebGLRenderTarget";
import {createFramebuffer} from "./createFramebuffer";

export type CreateRenderTargetOptions = {
    width: number;
    height: number;
    texture: WebGLTexture;
};

export const createRenderTarget = (
    gl: WebGLRenderingContext,
    options: CreateRenderTargetOptions
): WebGLRenderTarget => {

    const framebuffer = createFramebuffer(gl, options);

    return {
        ...options,
        framebuffer
    };
};